import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'app-display-only-icon',
  templateUrl: './display-only-icon.component.html',
  styleUrls: ['./display-only-icon.component.scss'],
  imports: [IonIcon],
})
export class DisplayOnlyIconComponent {
  readonly router = inject(Router);

  readonly icon = input.required<string | undefined>();
  readonly route = input.required<string | undefined>();
  readonly displayText = input('');
  readonly hasDisplayText = input(false);

  readonly emitClick = output<void>();

  get isActive(): any {
    return this.router.url.includes(this.route() as string);
  }
}
